import { Reveal, ArrowLink } from "./Reveal";
import NetworkGraphic from "./NetworkGraphic";
import { MapPin } from "lucide-react";

export default function House() {
  return (
    <section
      id="ventures"
      data-testid="ventures-section"
      className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12 lg:py-28"
    >
      <Reveal>
        <div className="relative overflow-hidden rounded-sm border border-hairline bg-surface/50 p-8 sm:p-12">
          <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-steel/10 blur-[90px]" />

          <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
            <div className="max-w-2xl">
            <div className="mb-6 flex items-center gap-3">
              <span className="font-body text-xs font-semibold tracking-[0.3em] text-steel-light">
                04
              </span>
              <span className="h-px w-8 bg-hairline" />
              <span className="font-body text-xs uppercase tracking-[0.3em] text-fog">
                Group Ventures
              </span>
            </div>

            <h2 className="font-display text-2xl font-bold tracking-tight text-cloud sm:text-3xl">
              Al Yakhour House
            </h2>

            <p className="mt-5 flex items-center gap-2 font-body text-xs uppercase tracking-[0.2em] text-fog">
              <MapPin size={14} className="text-steel-light" /> Haifa · Hospitality
            </p>

            <p className="mt-6 font-body text-sm font-light leading-relaxed text-fog sm:text-base">
              Beyond software and media, Al Yakhour LLC&apos;s founder, Saher, personally
              holds a 50% ownership stake in Al Yakhour House &mdash; a hostel, restaurant,
              and bar in Haifa. It&apos;s where the group&apos;s ambitions meet the real
              world &mdash; hospitality done with intent.
            </p>

            <div className="mt-8">
              <ArrowLink href="https://alyakhourhostel.com" testid="house-visit-btn">
                alyakhourhostel.com
              </ArrowLink>
            </div>
            </div>

            <NetworkGraphic
              variant="ventures"
              label="Hostel · Restaurant · Bar"
              badge="Haifa"
              className="aspect-[5/4] w-full"
            />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
